import { apiWobaBackend } from "@/services/api-woba-backend";
import { AxiosError } from "axios";
import { createToast } from "vercel-toast";
import {
  CreateUpSellApiParams,
  CreateUpSellApiResponse,
} from "./create-upsell.types";

const validateToast = (data: CreateUpSellApiResponse) => {
  if (data?.error && data?.message) {
    const message = Array.isArray(data.message)
      ? data.message[0]
      : data.message;
    createToast(message, {
      type: "error",
      timeout: 4000,
    });
  }
};

export const CreateUpSellAPi = async (params: CreateUpSellApiParams) => {
  try {
    const dataFormatted = {
      beginDate: new Date(params.data.beginDate).toISOString(),
      cyclesToUpdate: params.data.cyclesToUpdate,
    };

    const { data } = await apiWobaBackend.post<CreateUpSellApiResponse>(
      `/companies/${params.data.companyId}/packages/${params.data.packageId}/upsell`,
      dataFormatted,
    );

    validateToast(data);

    return {
      success: true,
      data: data,
    };
  } catch (err) {
    const error = err as AxiosError;

    validateToast(error.response?.data as CreateUpSellApiResponse);

    return {
      success: false,
      data: error?.response?.data as CreateUpSellApiResponse,
    };
  }
};
